import { MarketsNearMeQuery } from 'components/pages/TrucksNearbyPage/types/marketsNearMe'
import Image from 'components/Image'
import React from 'react'
import { ArrowRightIcon } from '@heroicons/react/solid'
import useInfoDialog from 'hooks/useInfoDialog'

type NearbyMarketsCardsProps = {
  markets: MarketsNearMeQuery['nearbyMarkets']['records']
}

const MapImage = ({ url }: { url: string }) => {
  return (
    <div className="relative w-[100%] md:w-96 h-56">
      <Image
        alt="Photo of the market"
        layout="fill"
        objectFit="cover"
        objectPosition="50% 50%"
        quality={50}
        sizes="(max-width: 768px) 50vw,25vw"
        src={url}
        priority
      />
    </div>
  )
}

const NearbyMarketsCards = ({ markets }: NearbyMarketsCardsProps) => {
  const infoDialog = useInfoDialog()
  const onShowAttribution = () => {
    const authors = markets.map((m) => m.imageAuthor || m.imageLicense)
    infoDialog({
      title: 'Photo Information',
      content: authors.length ? (
        <div>
          Photo authors:
          <ul>
            {markets
              .filter((m) => m.imageAuthor || m.imageLicense)
              .map((m) => (
                <div key={m.id}>
                  {m.name}
                  {m.imageAuthor && (
                    <span>
                      {' by '}
                      {m.imageAuthorUrl ? (
                        <a
                          className="underline text-blue-500"
                          href={m.imageAuthorUrl}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          {m.imageAuthor}
                        </a>
                      ) : (
                        <span>{m.imageAuthor}</span>
                      )}
                    </span>
                  )}
                  {m.imageLicense && (
                    <>
                      <span>
                        {' '}
                        (license: <span>{m.imageLicense}</span>)
                      </span>
                    </>
                  )}
                </div>
              ))}
          </ul>
        </div>
      ) : (
        <div />
      )
    })
  }
  return (
    <div className="w-full relative pb-6 md:pb-0">
      <div className="gap-y-6 flex lg:flex-row flex-col justify-between items-center lg:gap-x-8 lg:gap-y-0">
        {markets.map((market) => (
          <a
            key={market.name}
            className="group block w-[100%] md:w-96 bg-white rounded-lg shadow-lg overflow-hidden"
            href={market.customerPath}
          >
            <div aria-hidden="true" className="group-hover:opacity-75">
              <MapImage url={market.image.original!} />
            </div>
            <div className="p-4">
              <h3 className="text-xl font-bold text-gray-900">{market.name}</h3>
              <p className="text-orange-700 group-hover:underline">
                Browse trucks in {market.name}{' '}
                <span>
                  <ArrowRightIcon className="inline h-4 w-4" />
                </span>
              </p>
            </div>
          </a>
        ))}
      </div>
      <div className="text-right mt-2">
        <a
          className="text-gray-400 italic font-light underline text-sm"
          href="#"
          onClick={() => onShowAttribution()}
        >
          Photo authors
        </a>
      </div>
    </div>
  )
}

export default NearbyMarketsCards
